import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { Container } from 'components/ui/Container';
import { SocialIconView } from 'components/ui/icons/socialIcons/types';
import { useLocalStore } from 'hooks/useLocalStore';
import { FooterStoreProvider, FooterStore } from 'stores/local/FooterStore';
import { accessibilityParamsStore } from 'stores/root';

import SocialList from '../Header/SideMenu/SocialList';

import AppLinks from './AppLinks';
import Copyright from './Copyright';
import LegalList from './LegalList';

import s from './Footer.module.scss';

type FooterProps = {
  className?: string;
};

const Footer: React.FC<FooterProps> = ({ className }) => {
  const store = useLocalStore(() => new FooterStore());

  const { isOpen: isAccessibilityMode } = accessibilityParamsStore;

  return (
    <FooterStoreProvider store={store}>
      <Container className={cn(s.root, isAccessibilityMode && s.root_accessibility, className)} element="footer">
        <div className={s.root__text}>
          <Copyright className={s.root__copyright} />
          <LegalList />
        </div>
        <SocialList className={s.root__socials} view={SocialIconView.primary} />
        <AppLinks />
      </Container>
    </FooterStoreProvider>
  );
};

export default observer(Footer);
